module.exports = __webpack_public_path__ + "img/2.1c2b7cc1.png";